import React, { useEffect, useMemo, useRef } from "react";
import { useSearchParams } from "react-router-dom";

import headerIcon from "../../../static/img/img-ihr-by-bodymatter-hr-logo-black-sm@3x.png";
import blueCheck from "../../../static/img/icon-checkmark-full-knockout-lm@3x.png";

import "./VerifyAccount.scss";
import { useAuthContext } from "../../../hooks/context/AuthContext";

const VerifyAccount: React.FC = () => {
    const [searchParams] = useSearchParams();
    const sentRef = useRef(false);

    const { webVerifyAccount } = useAuthContext();

    const email = useMemo(() => (searchParams.get("email") ?? "").trim(), [searchParams]);

    const emailDisplay = useMemo(() => {
        const raw = String(email || "").trim();
        if (!raw || raw === "null" || raw === "undefined") return "";
        return raw.length > 254 ? raw.slice(0, 254) : raw;
    }, [email]);

    useEffect(() => {
        if (sentRef.current) return;
        if (!email) return;

        sentRef.current = true;

        webVerifyAccount(
            email,
            () => {},
            (err) => {
                console.error("VerifyAccount failed:", err);
            },
        );
    }, [email, webVerifyAccount]);

    return (
        <div className="VerifyAccount">
            <div className="VerifyAccount__content">
                <img
                    src={headerIcon}
                    loading="lazy"
                    alt="Instant Heart Rate"
                    className="VerifyAccount__logo"
                />

                <img
                    src={blueCheck}
                    loading="lazy"
                    alt="Verified"
                    className="VerifyAccount__check"
                />

                <h4 className="VerifyAccount__title">Account verified</h4>

                <p className="VerifyAccount__message">
                    You’ve successfully verified your account{emailDisplay ? (
                        <>
                            {" "}
                            for <b>{emailDisplay}</b>.
                        </>
                    ) : (
                        "."
                    )}
                </p>

                <button
                    className="VerifyAccount__button"
                    type="button"
                    onClick={() => {
                        const url = process.env.REACT_APP_UNIVERSAL_DEEP_LINK;
                        if (url) {
                            window.location.assign(url);
                        } else {
                            console.error("Missing REACT_APP_UNIVERSAL_DEEP_LINK");
                        }
                    }}
                >
                    Open Instant Heart Rate
                </button>
            </div>
        </div>
    );
};

export default VerifyAccount;
